/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowLineDownLeft(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M181.65723,82.34277a8.00122,8.00122,0,0,1,0,11.31446L125.31445,150l44.34278,44.34277A8.00038,8.00038,0,0,1,164,208H64a8.00039,8.00039,0,0,1-8-8V100a8.00065,8.00065,0,0,1,13.65723-5.65723L114,138.68579l56.34277-56.343A8.003,8.003,0,0,1,181.65723,82.34277ZM216,32.00391H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowLineDownLeft;
